const t=t=>!!t&&t.offsetWidth<t.scrollWidth;export{t as isEllipsisActive};
//# sourceMappingURL=index.js.map
